import { useState } from 'react';
import { FormTitle, TextArea } from '@molecules/TextArea/TextArea';
import { NavigationButtons } from '@molecules/TextArea/TextArea';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../../../../routes/Routes';
import { usePlanningBreachStore } from '../../../../hooks/usePlanningBreachStore';
import { ErrorMessages } from '@types';
import { parseZodErrors } from '@utils';
import { ZodError } from 'zod';
import { ErrorSummary } from '@atoms/ErrorSummary/ErrorSummary';
import { issueSchema } from '../../../../validations';

const issueInfoLabelText =
  'What type of plant or equipment has been installed?';
const issueInfoDescription = 'For example, a crane or large power tools.';

const locationOfIssueInfoLabelText =
  'Where is the plant or equipment installed?';
const locationOfIssueInfoDescription = `For example, in the basement or on the roof.`;

export const TellUsMoreInstallation = () => {
  const { data, update } = usePlanningBreachStore();
  const navigate = useNavigate();
  const formTitle = 'Tell us about the issue';
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);

  const handleChangeissueInfo = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    update('issueInfo', event.currentTarget.value);
    setErrorMessages([]);
  };

  const handleChangeLocationOfIssueInfo = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    update('locationOfIssueInfo', event.currentTarget.value);
    setErrorMessages([]);
  };

  const buttonNext = {
    onClick: () => {
      try {
        issueSchema.parse({
          locationOfIssueInfo: data.locationOfIssueInfo,
          issueInfo: data.issueInfo,
        });
        navigate(RoutesList.INSTALLATION_RESPONSIBILITY);
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  const buttonPrevious = {
    label: 'Previous',
    onClick: () => navigate(RoutesList.INSTALLATION_DATE),
  };

  return (
    <>
      <FormTitle text={formTitle} />
      <ErrorSummary messages={errorMessages} />
      <TextArea
        labelText={issueInfoLabelText}
        isLabelTextTitle={false}
        description={issueInfoDescription}
        value={data.issueInfo}
        onChange={handleChangeissueInfo}
        errorPath={'issueInfo'}
        errorMessages={errorMessages}
      />
      <TextArea
        labelText={locationOfIssueInfoLabelText}
        isLabelTextTitle={false}
        description={locationOfIssueInfoDescription}
        value={data.locationOfIssueInfo}
        onChange={handleChangeLocationOfIssueInfo}
        errorPath={'locationOfIssueInfo'}
        errorMessages={errorMessages}
      />
      <NavigationButtons
        buttonNext={buttonNext}
        buttonPrevious={buttonPrevious}
      />
    </>
  );
};
